define('responsive-gameday/views/render/PregameMatchupViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/pregame/matchupTeam'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function PregameMatchupViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/pregame/matchupTeam'),{
            }
        );
    }
    ViewRender.spawn(PregameMatchupViewRender);

    Superclass=PregameMatchupViewRender.superclass;

    return PregameMatchupViewRender;
});
